// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 닉네임 변경 모달 스타일 */

.nickname-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;
}

.nickname-modal {
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    max-height: calc(90vh / var(--app-zoom, 1));
    overflow-y: auto;
    position: relative;
    animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

.nickname-modal-header {
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid #e9ecef;
    position: relative;
}

.nickname-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
    text-align: center;
    padding-right: 30px;
}

.nickname-modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
    line-height: 1;
    transition: color 0.2s ease;
}

.nickname-modal-close:hover:not(:disabled) {
    color: #495057;
}

.nickname-modal-close:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.nickname-modal-form {
    padding: 24px;
}

.current-nickname {
    background-color: #f8f9fa;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 20px;
    border: 1px solid #e9ecef;
}

.current-nickname-label {
    font-size: 13px;
    color: #6c757d;
    font-weight: 500;
    margin-right: 8px;
}

.current-nickname-value {
    font-size: 14px;
    color: #333;
    font-weight: 600;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
}

.form-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    background-color: #fff;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #6c757d;
    box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.1);
}

.form-input:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
    opacity: 0.7;
}

.form-input::placeholder {
    color: #adb5bd;
}

.nickname-hint {
    margin-top: 6px;
}

.nickname-hint small {
    color: #6c757d;
    font-size: 12px;
    line-height: 1.4;
}

.error-message {
    background-color: #ffeaa7;
    border: 1px solid #fdcb6e;
    color: #e17055;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.error-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.error-text {
    flex: 1 1;
    line-height: 1.4;
}

.success-message {
    background-color: #d4edda;
    border: 1px solid #81c784;
    color: #2e7d32;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.success-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.success-text {
    flex: 1 1;
    line-height: 1.4;
}

.nickname-modal-buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
}

.nickname-button {
    flex: 1 1;
    padding: 14px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.nickname-button.primary {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    color: white;
}

.nickname-button.primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #5a6268 0%, #3d4142 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.nickname-button.secondary {
    background-color: #f8f9fa;
    color: #495057;
    border: 2px solid #e9ecef;
}

.nickname-button.secondary:hover:not(:disabled) {
    background-color: #e9ecef;
    border-color: #dee2e6;
    transform: translateY(-1px);
}

.nickname-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
}

/* 로딩 상태 애니메이션 */
.nickname-button.primary:disabled {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    position: relative;
}

.nickname-button.primary:disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    animation: loading 1.5s infinite;
}

@keyframes loading {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

/* 반응형 디자인 */
@media (max-width: 480px) {
    .nickname-modal-overlay {
        padding: 10px;
    }
    
    .nickname-modal {
        max-width: 100%;
    }
    
    .nickname-modal-header {
        padding: 20px 16px 12px 16px;
    }
    
    .nickname-modal-form {
        padding: 16px;
    }
    
    .nickname-modal-title {
        font-size: 18px;
        padding-right: 25px;
    }
    
    .nickname-modal-buttons {
        flex-direction: column;
        gap: 10px;
    }
    
    .nickname-button {
        padding: 12px 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NicknameChangeModal.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,gCAAgC;AACpC;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* 닉네임 변경 모달 스타일 */\r\n\r\n.nickname-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.nickname-modal {\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\r\n    width: 100%;\r\n    max-width: 400px;\r\n    max-height: calc(90vh / var(--app-zoom, 1));\r\n    overflow-y: auto;\r\n    position: relative;\r\n    animation: modalFadeIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes modalFadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.9) translateY(-20px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1) translateY(0);\r\n    }\r\n}\r\n\r\n.nickname-modal-header {\r\n    padding: 24px 24px 16px 24px;\r\n    border-bottom: 1px solid #e9ecef;\r\n    position: relative;\r\n}\r\n\r\n.nickname-modal-title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin: 0;\r\n    text-align: center;\r\n    padding-right: 30px;\r\n}\r\n\r\n.nickname-modal-close {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    color: #6c757d;\r\n    cursor: pointer;\r\n    padding: 4px;\r\n    line-height: 1;\r\n    transition: color 0.2s ease;\r\n}\r\n\r\n.nickname-modal-close:hover:not(:disabled) {\r\n    color: #495057;\r\n}\r\n\r\n.nickname-modal-close:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.nickname-modal-form {\r\n    padding: 24px;\r\n}\r\n\r\n.current-nickname {\r\n    background-color: #f8f9fa;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.current-nickname-label {\r\n    font-size: 13px;\r\n    color: #6c757d;\r\n    font-weight: 500;\r\n    margin-right: 8px;\r\n}\r\n\r\n.current-nickname-value {\r\n    font-size: 14px;\r\n    color: #333;\r\n    font-weight: 600;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-label {\r\n    display: block;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.form-input {\r\n    width: 100%;\r\n    padding: 12px 16px;\r\n    border: 2px solid #e1e5e9;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    background-color: #fff;\r\n    transition: all 0.2s ease;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.form-input:focus {\r\n    outline: none;\r\n    border-color: #6c757d;\r\n    box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.1);\r\n}\r\n\r\n.form-input:disabled {\r\n    background-color: #f8f9fa;\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n}\r\n\r\n.form-input::placeholder {\r\n    color: #adb5bd;\r\n}\r\n\r\n.nickname-hint {\r\n    margin-top: 6px;\r\n}\r\n\r\n.nickname-hint small {\r\n    color: #6c757d;\r\n    font-size: 12px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.error-message {\r\n    background-color: #ffeaa7;\r\n    border: 1px solid #fdcb6e;\r\n    color: #e17055;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    margin-bottom: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.error-icon {\r\n    font-size: 16px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.error-text {\r\n    flex: 1;\r\n    line-height: 1.4;\r\n}\r\n\r\n.success-message {\r\n    background-color: #d4edda;\r\n    border: 1px solid #81c784;\r\n    color: #2e7d32;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    margin-bottom: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.success-icon {\r\n    font-size: 16px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.success-text {\r\n    flex: 1;\r\n    line-height: 1.4;\r\n}\r\n\r\n.nickname-modal-buttons {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-top: 24px;\r\n}\r\n\r\n.nickname-button {\r\n    flex: 1;\r\n    padding: 14px 20px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    text-align: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.nickname-button.primary {\r\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\r\n    color: white;\r\n}\r\n\r\n.nickname-button.primary:hover:not(:disabled) {\r\n    background: linear-gradient(135deg, #5a6268 0%, #3d4142 100%);\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\r\n}\r\n\r\n.nickname-button.secondary {\r\n    background-color: #f8f9fa;\r\n    color: #495057;\r\n    border: 2px solid #e9ecef;\r\n}\r\n\r\n.nickname-button.secondary:hover:not(:disabled) {\r\n    background-color: #e9ecef;\r\n    border-color: #dee2e6;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.nickname-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: none !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n/* 로딩 상태 애니메이션 */\r\n.nickname-button.primary:disabled {\r\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\r\n    position: relative;\r\n}\r\n\r\n.nickname-button.primary:disabled::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n    animation: loading 1.5s infinite;\r\n}\r\n\r\n@keyframes loading {\r\n    0% {\r\n        left: -100%;\r\n    }\r\n    100% {\r\n        left: 100%;\r\n    }\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 480px) {\r\n    .nickname-modal-overlay {\r\n        padding: 10px;\r\n    }\r\n    \r\n    .nickname-modal {\r\n        max-width: 100%;\r\n    }\r\n    \r\n    .nickname-modal-header {\r\n        padding: 20px 16px 12px 16px;\r\n    }\r\n    \r\n    .nickname-modal-form {\r\n        padding: 16px;\r\n    }\r\n    \r\n    .nickname-modal-title {\r\n        font-size: 18px;\r\n        padding-right: 25px;\r\n    }\r\n    \r\n    .nickname-modal-buttons {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n    \r\n    .nickname-button {\r\n        padding: 12px 16px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
